/**
 * Notices one-shot affichées en bannière sous la navigation (NoticeBanner).
 *
 * Une notice est montrée uniquement aux comptes créés AVANT `audienceBefore`
 * (les comptes créés après ne la voient jamais) et absents de
 * `users.dismissed_notices`. Elle est marquée vue dès son premier affichage :
 * elle ne réapparaît pas aux connexions suivantes, sur aucun appareil.
 *
 * Ajouter un message = ajouter une entrée ici, aucune migration nécessaire.
 * - id : unique et stable (c'est ce qui est stocké en base)
 * - audienceBefore : date de mise en prod de la feature annoncée
 * - action (optionnel) : bouton ouvrant les paramètres sur l'onglet donné
 */
export const NOTICES = [
    {
        id: 'theme-glass-2026-07',
        audienceBefore: '2026-07-29T00:00:00Z',
        message: "L'interface fait peau neuve ! Vous préfériez les anciennes couleurs ? Vous pouvez revenir au thème classique dans les paramètres.",
        action: { label: 'Choisir mon thème', settingsTab: 'theme' }
    }
];

/** Première notice encore due pour cet utilisateur, ou undefined. */
export const pendingNoticeFor = (user) => {
    if (!user?.created_at) return undefined;
    return NOTICES.find(
        (n) =>
            !user.dismissed_notices?.includes(n.id) &&
            new Date(user.created_at) < new Date(n.audienceBefore)
    );
};
